import React from "react";
import { Outlet } from "react-router-dom";
import MaxHeader from "./MaxHeader";
import MaxFooter from "./MaxFooter";
import { EnquiryModalProvider } from "../context/EnquiryModalContext";
import "../max-website.css";

const MaxLayout = () => {
  return (
    <div className="max-site-root">
      <EnquiryModalProvider>
        <MaxHeader />
        <main>
          <Outlet />
        </main>
        <MaxFooter />
      </EnquiryModalProvider>
    </div>
  );
};

export default MaxLayout;
